





















import { Component, Mixins, Watch } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { InvoiceConsolidationTypes } from "@/data/enums/invoice";

// Types
import { IContractProduct } from "@/models/contracts";

@Component({
  components: {
    "invoice-consolidation-enabled-field": () =>
      import(
        "@/components/app/global/invoices/invoiceConsolidationEnabledField.vue"
      )
  }
})
export default class CProdInvoiceConsolidationForm extends Mixins(
  CProdInjectorMixin,
  HasValidation
) {
  // Data

  public isProcessing = false;
  public form = {} as Pick<IContractProduct, "invoice_consolidation_enabled">;

  // Life-cycle methods

  public created() {
    this.initialiseForm();
  }

  // Methods

  public initialiseForm() {
    this.form = this.initForm();
  }

  public initForm() {
    return _.pick(this.cProdData.contractProduct, [
      "invoice_consolidation_enabled"
    ]);
  }

  public async validateBeforeSubmit() {
    try {
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      this.isProcessing = true;

      await this.$cProdMethods.updateInvoiceConsolidation(this.form);
      await this.$cProdMethods.reloadData();

      this.initialiseForm();

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.invoice.consolidation_preferences_updated")
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public revertToInitialState() {
    this.initialiseForm();
  }

  // Computed

  public get invoiceConsolidationOptions() {
    return [
      {
        value: InvoiceConsolidationTypes.ENABLED,
        leftLabel: this.$t("_sentence.invoice.include_when_consolidating")
      },
      {
        value: InvoiceConsolidationTypes.DISABLED,
        leftLabel: this.$t("_sentence.invoice.exclude_from_consolidation")
      }
    ];
  }

  public get invoiceConsolidationInheritValue() {
    return InvoiceConsolidationTypes.INHERIT;
  }

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsChanged || this.hasErrors;
  }

  public get formIsChanged() {
    return !this.$_.isEqual(this.form, this.initForm());
  }

  // Watchers

  @Watch("formIsChanged")
  public onIsEnabledChange() {
    this.$emit("isEnabled", this.formIsChanged);
  }

  @Watch("isProcessing")
  public onIsProcessingChange() {
    this.$emit("isProcessing", this.isProcessing);
  }
}
